var _line, _line2, _line3, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 492.26186,
    height: 316.5234,
    viewBox: "0 0 492.26186 316.5234",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40.77909,
    y1: 7.76744,
    x2: 143.24681,
    y2: 7.76744,
    fill: "none",
    stroke: "#0f172a",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40.77909,
    y1: 46.60467,
    x2: 256.32569,
    y2: 46.60467,
    fill: "none",
    stroke: "#0f172a",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 40.77909,
    y1: 29.12791,
    x2: 349.53505,
    y2: 29.12791,
    fill: "none",
    stroke: "#0f172a",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.47675,
    cy: 17.47675,
    r: 17.47675,
    fill: "#234ba2",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m477.3115,316.5234H54.7585c-8.2439,0-14.95034-6.70739-14.95034-14.95082V80.00317c0-8.24342,6.70643-14.95081,14.95034-14.95081h422.55304c8.24392,0,14.95032,6.70739,14.95032,14.95082v221.56941c0,8.24343-6.70644,14.95082-14.95032,14.95082h-.00004Z",
    fill: "#eef0f4",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallEmptyState);
export default __webpack_public_path__ + "static/media/wall-empty-state.6a2e0587de85a40c270d949a2a50918b.svg";
export { ForwardRef as ReactComponent };